// Languages for Kendo UI
import { HttpClient } from '@angular/common/http';
import '@progress/kendo-angular-intl/locales/ar/all'; // Arabic
import '@progress/kendo-angular-intl/locales/bg/all'; // Bulgarian
import '@progress/kendo-angular-intl/locales/cs/all'; // Czech
import '@progress/kendo-angular-intl/locales/da/all'; // Danish
import '@progress/kendo-angular-intl/locales/de-CH/all'; // German
import '@progress/kendo-angular-intl/locales/de/all'; // German
import '@progress/kendo-angular-intl/locales/el/all'; // Greek
import '@progress/kendo-angular-intl/locales/en/all'; // English
import '@progress/kendo-angular-intl/locales/es/all'; // Spanish
import '@progress/kendo-angular-intl/locales/et/all'; // Estonian
import '@progress/kendo-angular-intl/locales/fi/all'; // Finnish
import '@progress/kendo-angular-intl/locales/fr/all'; // French
import '@progress/kendo-angular-intl/locales/hi/all'; // Hindi
import '@progress/kendo-angular-intl/locales/hr/all'; // Croatian
import '@progress/kendo-angular-intl/locales/hu/all'; // Hungarian
import '@progress/kendo-angular-intl/locales/it/all'; // Italian
import '@progress/kendo-angular-intl/locales/ja/all'; // Japanese
import '@progress/kendo-angular-intl/locales/ko/all'; // Korean
import '@progress/kendo-angular-intl/locales/lt/all'; // Lithuanian
import '@progress/kendo-angular-intl/locales/lv/all'; // Latvian
import '@progress/kendo-angular-intl/locales/nb/all'; // Norsk
import '@progress/kendo-angular-intl/locales/nl/all'; // Dutch
import '@progress/kendo-angular-intl/locales/pl/all'; // Polish
import '@progress/kendo-angular-intl/locales/pt/all'; // Portuguese
import '@progress/kendo-angular-intl/locales/ro/all'; // Romanian
import '@progress/kendo-angular-intl/locales/ru/all'; // Russian
import '@progress/kendo-angular-intl/locales/sk/all'; // Slovak
import '@progress/kendo-angular-intl/locales/sl/all'; // Slovenian
import '@progress/kendo-angular-intl/locales/sq/all'; // Albanian
import '@progress/kendo-angular-intl/locales/sv/all'; // Svedish
import '@progress/kendo-angular-intl/locales/th/all'; // Thai
import '@progress/kendo-angular-intl/locales/tr/all'; // Turkish
import '@progress/kendo-angular-intl/locales/zh/all'; // Chinese

import { HttpLocalizationLoader } from './services/http-localization-loader';

// kendo
export function createTranslateLoader(httpClient: HttpClient) {
  return new HttpLocalizationLoader(httpClient);
}
